__turbopack_context__.v({
  "charCount": "FormTextArea-module-scss-module__Z9lbDa__charCount",
  "charCountError": "FormTextArea-module-scss-module__Z9lbDa__charCountError",
  "charCounter": "FormTextArea-module-scss-module__Z9lbDa__charCounter",
  "counter": "FormTextArea-module-scss-module__Z9lbDa__counter",
  "description": "FormTextArea-module-scss-module__Z9lbDa__description",
  "descriptionRow": "FormTextArea-module-scss-module__Z9lbDa__descriptionRow",
  "descriptionRowAfterInput": "FormTextArea-module-scss-module__Z9lbDa__descriptionRowAfterInput",
  "error": "FormTextArea-module-scss-module__Z9lbDa__error",
  "errorMsg": "FormTextArea-module-scss-module__Z9lbDa__errorMsg",
  "field": "FormTextArea-module-scss-module__Z9lbDa__field",
  "fieldDescription": "FormTextArea-module-scss-module__Z9lbDa__fieldDescription",
  "fieldDescriptionTop": "FormTextArea-module-scss-module__Z9lbDa__fieldDescriptionTop",
  "input": "FormTextArea-module-scss-module__Z9lbDa__input",
  "inputContent": "FormTextArea-module-scss-module__Z9lbDa__inputContent",
  "inputElement": "FormTextArea-module-scss-module__Z9lbDa__inputElement",
  "label": "FormTextArea-module-scss-module__Z9lbDa__label",
  "labelWrapper": "FormTextArea-module-scss-module__Z9lbDa__labelWrapper",
  "optional": "FormTextArea-module-scss-module__Z9lbDa__optional",
  "required": "FormTextArea-module-scss-module__Z9lbDa__required",
});
